import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { Lci3DimensionTableData } from '@features/lci-report';
import { groupBy } from 'lodash';

type DimensionEntry = {
  dimension: string;
  subdimensions: Lci3Report['subdimensions'];
};

export const paginateSubdimensions = (
  data: Lci3DimensionTableData,
  subdimensionsPerSlide: number
): DimensionEntry[] => {
  const subdimensionsByPage = Object.entries(data).reduce(
    (acc, [dimension, subdimensions]) => {
      const subdimensionPages = Math.ceil(
        subdimensions.length / subdimensionsPerSlide
      );

      const pages = Array.from({ length: subdimensionPages }, (_, i) => {
        const startIndex = i * subdimensionsPerSlide;
        const endIndex = Math.min(
          subdimensions.length,
          (i + 1) * subdimensionsPerSlide
        );
        const subdimensionPage = subdimensions.slice(startIndex, endIndex);

        return {
          dimension,
          subdimensions: subdimensionPage,
        };
      });

      return [...acc, ...pages];
    },
    [] as { dimension: string; subdimensions: Lci3Report['subdimensions'] }[]
  );

  return subdimensionsByPage;
};

type DimensionGrouping = Record<string, DimensionEntry[]>;

export const groupByDimension = (
  subdimensionsByPage: ReturnType<typeof paginateSubdimensions>
): DimensionGrouping =>
  groupBy(subdimensionsByPage, dimensionPage => dimensionPage.dimension);
